<template>
    <div>
        <div class="contact-name">
            {{ contactName }}
        </div>

        <DisplayAddress
            data-qa="invoice-address"
            class="contact-address fs-block"
            :address1="shippingInformation.street1"
            :address2="shippingInformation.street2"
            :city="shippingInformation.city"
            :state="shippingInformation.state"
            :zip="shippingInformation.zip"
            :country="shippingInformation.country"
        />
    </div>
</template>

<script>
import { DisplayAddress, getContactFullName } from '@keap-web/shared-ui';

export default {
    components: {
        DisplayAddress,
    },

    props: {
        contact: {
            type: Object,
            default: () => {},
        },
        shippingInformation: {
            type: Object,
            default: () => {},
        },
        status: String,
    },

    computed: {
        contactName() {
            return this.shippingInformation?.invoiceToCompany ? this.contact?.company : getContactFullName(this.contact);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../styles/common';

.contact-name {
    font-size: $font-size-md;
}

.contact-address {
    font-size: $font-size-sm;
}

@media only screen and ($small) {
    .contact-name {
        font-size: $font-size-lg;
    }

    .contact-address {
        display: none;
    }
}
</style>
